// Vue
import { Component, Watch } from "vue-property-decorator";
// Template
import template from "./template.vue";
// Base Module
import ModuleBase from "#/common/ModuleBase";
// Components
import ModuleWrapper from "#/components/module_wrapper/ModuleWrapper";
import UnimogCheckbox from "#/components/unimog_checkbox/UnimogCheckbox";
import { Observer } from "mobx-vue";
import { Api } from "../../../api";
import { UnimogProduct } from "../../../common/interfaces/unimog/UnimogProduct";
import { UnimogPartner } from "../../../common/interfaces/unimog/UnimogPartner";
import { ImageAspectRatio } from "../../../components/image_aspect_ratio/ImageAspectRatio";
import { DownloadLink } from "../../../components/download_link/DownloadLink";
import { Filter } from "../../../common/interfaces/unimog/Filter";

@Observer
@Component({
  mixins: [template],
  components: {
    ModuleWrapper,
    ImageAspectRatio,
    DownloadLink,
  },
})
export class PagePartnerModule extends ModuleBase {
  private partner: UnimogPartner | null = null;

  private isEconic: boolean = window.location.hostname.indexOf("econic") > 0;

  private readonly maxVisibleProducts: number = 5;

  public getBackgroundColorFromInstance(instance: object) {
    return "white";
  }

  public created() {
    let id = this.$store.page!.page!.route_parameter["id"];
    let slug = this.$store.page!.page!.route_parameter["slug"];

    if (id) {
      this.loadPartner(id, slug);
    }
  }

  private async loadPartner(id, slug) {
    this.partner = await Api.unimog.getPartner(id, slug);
  }

  private getDownloadText(download, i) {
    return (
      this.instance["translation"]["download_broschuere"] +
      (this.partner!.downloads.length > 1 ? " " + (i + 1) : "") +
      (download.language ? " (" + download.language + ")" : "")
    );
  }

  private get visibleProducts() {
    if (this.partner && this.partner.produkte) {
      return this.partner.produkte.slice(0, this.maxVisibleProducts);
    } else {
      return [];
    }
  }

  private get hasMoreProducts() {
    if (this.partner && this.partner.produkte) {
      return this.partner.produkte.length > this.maxVisibleProducts;
    } else {
      return false;
    }
  }

  private onClickShowMoreProducts(event) {
    event.preventDefault();

    if (this.hasMoreProducts) {
      let id = this.$store.page!.page!.route_parameter["id"];
      let filter: Filter = {
        freitext: "",
        baureihen: [],
        branchen: [],
        aufbaupartner: id,
        fahrzeugtyp: "",
        baumuster: "",
        euronorm: "",
        radstand: "",
        land: "",
        einsatzgebiet: "",
        partnerstatus: "",
      };

      window.localStorage.setItem("unimog-page-filter__tab", "product");
      window.localStorage.setItem(
        "unimog-page-filter__filter",
        JSON.stringify(filter)
      );

      window.location.href = "/" + this.lang + "/filter";
    }
  }

  private get moreProductsLink() {
    if (this.hasMoreProducts) {
      let id = this.$store.page!.page!.route_parameter["id"];
      return (
        "/" + this.lang + "/filter?f[abh]=" + id + "&f[active_tab]=product"
      );
    } else {
      return "";
    }
  }
}
